import { Component } from 'react';

interface Props {
  heading;
  content;
}

interface State {
  showFaq: boolean;
}

class DropdownNew extends Component<Props, State> {
  constructor(props: any) {
    super(props);

    this.state = {
      showFaq: false,
    };
  }

  public render() {
    return (
      <div>
        <div
          className="lil-flex lil-justify-between lil-py-6 lil-border-t-sm lil-border-grey-250 lil-items-center"
          onClick={() => this.setState({ showFaq: !this.state.showFaq })}
        >
          <h6 className="lil-text-base lil-font-semibold">
            {' '}
            {this.props.heading}
          </h6>
          <div>
            <svg
              width="16"
              height="8"
              viewBox="0 0 16 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              transform={this.state.showFaq ? 'scale(-1)' : ''}
            >
              <path
                d="M1 1L8 7L15 1"
                stroke="#9092A3"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className={this.state.showFaq ? 'lil-block' : 'lil-hidden'}>
          <div itemProp="text">
            <div>{this.props.content}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default DropdownNew;



// WEBPACK FOOTER //
// ./components/common/dropdownNew.tsx